import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "react-feather";

const GallerySliderComp = ({
  imgSlides,
  autoSlide = false,
  autoSlideInterval = 10000,
  showPills = true,
}) => {
  const [current, setCurrent] = useState(0);

  const prev = () =>
    setCurrent((current) =>
      current === 0 ? imgSlides.length - 1 : current - 1
    );
  const next = () =>
    setCurrent((current) =>
      current === imgSlides.length - 1 ? 0 : current + 1
    );

  useEffect(() => {
    if (!autoSlide) return;
    const slideInterval = setInterval(next, autoSlideInterval);
    return () => clearInterval(slideInterval);
  }, []);

  const getSlides = () => {
    return imgSlides.map((slide, index) => (
      <div key={index} style={{ width: '640px', flexShrink: 0 }}>
        <img
          src={`${slide.link}`}
          alt="Slide"
          className="w-[640px] h-full object-cover"
        />
      </div>
    ));
  };

  const shouldShowPills = showPills && imgSlides.length > 1;

  return (
    <div className="w-[640px] h-full overflow-hidden">
      <div
        className="flex h-full transition-transform ease-out duration-500"
        style={{ transform: `translateX(-${current * 640}px)` }}
      >
        {getSlides()}
      </div>
      {shouldShowPills && (
        <div className="absolute inset-0 flex items-center justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10">
          <button
            onClick={prev}
            className="p-2 rounded-full bg-white/90 text-primary-600 shadow-lg hover:bg-white hover:text-primary-700 transition-all duration-300 transform hover:scale-110"
          >
            <ChevronLeft size={32} />
          </button>
          <button
            onClick={next}
            className="p-2 rounded-full bg-white/90 text-primary-600 shadow-lg hover:bg-white hover:text-primary-700 transition-all duration-300 transform hover:scale-110"
          >
            <ChevronRight size={32} />
          </button>
        </div>
      )}
      {shouldShowPills && (
        <div className="absolute bottom-4 right-0 left-0 z-10">
          <div className="flex items-center justify-center gap-3">
            {imgSlides.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`w-3 h-3 rounded-full transition-all duration-300 transform hover:scale-110
                  ${current === i 
                    ? 'bg-primary-600 scale-110' 
                    : 'bg-white/90 hover:bg-white shadow-md'}`}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default GallerySliderComp;
